import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { intercom } from '../services/intercom';

export const useOpenSupportWithQs = () => {
  const [searchParams, setUrlSearchParams] = useSearchParams();

  useEffect(() => {
    const autoOpen = searchParams.get('ao');
    if (autoOpen && autoOpen === 'support') {
      intercom.handleOpenSupport();
      setUrlSearchParams('');
    }
  }, [searchParams, setUrlSearchParams]);
};
